export default __webpack_public_path__ + "static/media/playbtn.166e6b39.png";